// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"68db6490","280":"93dead3d","494":"dae740d2"}[chunkId] + ".chunk.js";
};